"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMBComplianceReport = void 0;
const shared_1 = require("@getgreenline/shared");
const getMBComplianceReport = (companyId, filter) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/reports/compliance`, {
            params: filter,
        });
        return response.data;
    }
    catch (error) {
        throw error;
    }
});
exports.getMBComplianceReport = getMBComplianceReport;
//# sourceMappingURL=MBComplianceApi.js.map